import React from "react";
import { Route } from "react-router-dom";
import FinancialSupport from "../components/index";

const FinancialSupportRoutes = () => {
  return (
    <>
      <Route path="/financial-support" element={<FinancialSupport />} /> 
    </>
  );
};

export default FinancialSupportRoutes;
